<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                (pageChanged)="search($event, null)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="count"
                [maxSize]="5"
                [itemsPerPage]="searchParams.per_page"
                ngDefaultControl
                [(ngModel)]="searchParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Wage"
                    pluralName="Wages"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="user">User:</label>
                        <select name="user_id" class="form-control" id="user" ngDefaultControl [(ngModel)]="searchParams['user_id']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                            <option [value]=""></option>
                            <option [value]="user.id" *ngFor="let user of searchOptions.users">{{user.name}}</option>
                        </select>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="from-date">Date From:</label>
                            <input type="text" class="form-control" #FilterFromDate="ngModel" name="from_date" ngDefaultControl [(ngModel)]="searchParams['search[date_from]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_from]'] = $event" id="fromDate" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="to-date">Date To:</label>
                            <input type="text" class="form-control" #FilterToDate="ngModel" name="to_date" ngDefaultControl [(ngModel)]="searchParams['search[date_to]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_to]'] = $event" id="toDate" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="order-by">Order By:</label>
                            <select name="order_by" class="form-control" id="order-by" ngDefaultControl [(ngModel)]="searchParams.order_by" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option value=""></option>
                                <option *ngFor='let orderBy of searchOptions.order_by' [value]='orderBy.value'>{{orderBy.label}}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="in-order-of">In Order Of:</label>
                            <select name="in_order_of" class="form-control" id="in-order-of" ngDefaultControl [(ngModel)]="searchParams.order_direction" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option value=""></option>
                                <option *ngFor='let orderDirection of searchOptions.order_direction' [value]='orderDirection.value'>{{orderDirection.label}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'all'">
                            <input [checked]="searchParams.reversal == 'all'" ngDefaultControl type="checkbox" name="type" class="custom-control-input" />
                            <label class="custom-control-label">All</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'hide_reversed'">
                            <input [checked]="searchParams.reversal == 'hide_reversed'" ngDefaultControl type="checkbox" name="type" class="custom-control-input" />
                            <label class="custom-control-label">Hide Reversed</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'only_reversed'">
                            <input [checked]="searchParams.reversal == 'only_reversed'" ngDefaultControl type="checkbox" name="type" class="custom-control-input" />
                            <label class="custom-control-label">Only Reversed</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <app-search-btn [searching]="searching" (onClick)="searchParams.page = 1; search(null, true)"></app-search-btn>
                    </div>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Wages</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th></th>
                                <th>Group</th>
                                <th>Matter</th>
                                <th>Description</th>
                                <th>Date</th>
                                <th>Carry Over</th>
                                <th>New</th>
                                <th>Consumed</th>
                                <th>Gross</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let wage of wages">
                                <td><a [href]="'/wages/' + wage.id">{{wage.id}}</a></td>
                                <td><a [href]="wage.tree_link_path"><i class="fas fa-tree"></i></a></td>
                                <td><a [href]="'/entry_groups/' + wage.entry_group_id">{{wage.entry_group_id}}</a></td>
                                <td><a [routerLink]="'/matters/' + wage.matter_id">{{wage.matter.number}}</a></td>
                                <td [innerHtml] = "wage.description | safeHtml"></td>
                                <td>{{wage.date}}</td>
                                <td class="text-right">
                                    <span *ngIf="wage.amount">{{wage.amount | currency:'USD':'symbol'}}</span>
                                    <span *ngIf="!wage.amount"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="wage.factors_considered">{{wage.factors_considered | currency:'USD':'symbol'}}</span>
                                    <span *ngIf="!wage.factors_considered"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="wage.factors_consumed">{{wage.factors_consumed | currency:'USD':'symbol'}}</span>
                                    <span *ngIf="!wage.factors_consumed"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="wage.gross_ledger">{{wage.gross_ledger | currency:'USD':'symbol'}}</span>
                                    <span *ngIf="!wage.gross_ledger"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>